import api from "../../api/apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export

const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      params.append(key, p[key]);
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  monthly(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/monthly?${params}`);
  },
  employeeAttendance(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/employee-attendance?${params}`);
  },
  employeesCredit(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/employees-credit?${params}`);
  },
  leaveAppsMonthly(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/leave-apps-monthly?${params}`);
  },
  remotely(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/remotely-users?${params}`);
  },
  hierdResigned(p) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/users-hiring-release?${params}`);
  },
  employeeDaily(p, options = {}) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/employees-attendant?${params}`, {
      ...options,
    });
  },
  dailyWages(p, options = {}) {
    const params = paramsFactory(p);
    return api.get(`/api/v1/reports/daily-workers-salary?${params}`, {
      ...options,
    });
  },
};
